import React, {useEffect, useState} from 'react';
import {Button, Checkbox, ControlLabel, FormGroup} from 'react-bootstrap';
import FormControlLanguage from '../../../../UI/FormControlLanguage';

const TextSetting = ({
    eventSetting,
    title,
    property,
    toggleProperty,
    rows = 2,
    defaultText = '',
    onUpdate,
}) => {
    const PROPERTY_RU = `${property}Ru`;
    const PROPERTY_EN = `${property}En`;
    const [saving, setSaving] = useState(false);
    const [model, setModel] = useState({
        [PROPERTY_RU]: '',
        [PROPERTY_EN]: '',
    });
    const [isHidden, setHidden] = useState(eventSetting[toggleProperty] ?? false);

    useEffect(() => {
        setModel({
            [PROPERTY_RU]: eventSetting[PROPERTY_RU] || (defaultText?.ru ?? ''),
            [PROPERTY_EN]: eventSetting[PROPERTY_EN] || (defaultText?.en ?? ''),
        });
    }, [eventSetting, defaultText]);

    const handleSaveText = () => {
        setSaving(true);
        onUpdate(model);
        setSaving(false);
    };

    const handleToggleVisibility = (value) => {
        onUpdate({[toggleProperty]: value});
        setHidden(value);
    };

    return (
        <FormGroup>
            <div style={{display: 'flex', alignItems: 'center', columnGap: '20px'}}>
                <ControlLabel style={{margin: 0}}>
                    {title}
                </ControlLabel>
                <Checkbox
                    checked={isHidden}
                    value={isHidden}
                    name={toggleProperty}
                    onChange={(e) => handleToggleVisibility(e.target.checked)}
                >
                    Скрыть
                </Checkbox>
            </div>
            {!isHidden && (
                <>
                    <FormGroup>
                        <FormControlLanguage
                            componentClass="textarea"
                            rows={rows}
                            disabled={saving}
                            values={{
                                ru: model[PROPERTY_RU] || '',
                                en: model[PROPERTY_EN] || '',
                            }}
                            onChange={{
                                ru: (e) => setModel({...model, [PROPERTY_RU]: e.target.value}),
                                en: (e) => setModel({...model, [PROPERTY_EN]: e.target.value}),
                            }}
                        />
                    </FormGroup>
                    <Button onClick={handleSaveText}>
                        Сохранить
                    </Button>
                </>
            )}
        </FormGroup>
    )
}

export default TextSetting;
